export default __webpack_public_path__ + "static/media/miro_icon.5fcd50c2.svg";